import Box from '../../../Global/Box'
import InputController from '../../../Global/InputController'

const Image = ({ index, item, control, handleDeleteItem, handleFiles }) => {
  return (
    <Box
      title="Imagen"
      contentHeader={
        <>
          <h3 className="card-title pl-3 mt-0">Imagen</h3>
          <div className="card-tools mr-2">
            <button
              type="button"
              className="btn btn-sm btn-migrates"
              title="Eliminar item"
              onClick={() => handleDeleteItem({ index })}
            >
              <i className="fas fa-trash-alt" />
            </button>
          </div>
        </>
      }
      content={
        <>
          <div className="d-flex flex-wrap mb-3">
            <InputController
              label="Link"
              name={`image[${index}].link`}
              type="text"
              placeholderTxt="Escribe link"
              control={control}
            />
          </div>
          <div className="d-flex flex-wrap" style={{ gap: '20px 20px' }}>
            <div className="">
              <InputController
                label="Imagen"
                inputType="file"
                formatAccept="image/*"
                validateFormat="imageavatar"
                validateFormatMsg="Solo se admite JPG, JPGE y PNG"
                name={`image[${index}].file`}
                control={control}
                changeAction={(e) => handleFiles({ e, index })}
              />
            </div>
            {item?.url && item?.urlKey && (
              <div className="">
                <label>Imagen actual</label>
                <div>
                  <img src={item.url} width={'300px'} alt="Imagen" />
                </div>
              </div>
            )}
          </div>
        </>
      }
    />
  )
}

export default Image
